/*
  ** Note: This Widget will not work when viewing the PDP through a shopify preview link ( due to the different url ).

  *** OhiWidget has been discontinued ( shipping issues ) but may be re-installed in the future, keeping this here for now ***

*/

export class OhiWidget {
  constructor(product) {
    this.state = {
      isOpen: false,
      isDisabled: false,
      zipCode: false,
      hasError: false,
      title: product.title,
      handle: product.handle,
      sku: product.sku,
      widget: document.getElementById(`ohi-pdp-container`),
      spinner: document.getElementById(`ohi-spinner`),
      msgContainer: document.getElementById(`ohi-message`),
      toggleBtn: document.getElementById(`ohi-toggle`),
      inputContainer: document.getElementById(`ohi-inputContainer`),
      input: document.getElementById(`ohi-input`),
      submitBtn: document.getElementById(`ohi-submit`),
      messages: {
        next_day_availability_message:
          "Get it tomorrow with next day delivery to [zip], [city].",
        not_available_delivery_message:
          "Same day delivery is unavailable in [zip], [city]. Try entering another zip code or enjoy free shipping on orders over $50!",
        rush_availability_message:
          "Get it today with 2 hour delivery to [zip], [city].",
        same_day_availability_message: "Same day delivery available in [zip].",
        two_day_availability_message: "Two day delivery available in [zip].",
        error_out_message:
          "Same day delivery is unavailable in your area. Try entering another zip code or enjoy free shipping on orders over $50!",
        online_only_message:
          "Exclusively available online. Enjoy free shipping on orders over $50!",
      },
    };
  }

  _handleToggle = () => {
    var { toggleBtn, input, inputContainer, hasError } = this.state;

    this.state.isOpen = !this.state.isOpen;
    toggleBtn.innerHTML = this.state.isOpen ? "Cancel" : "Edit Location";
    toggleBtn.ariaExpanded = this.state.isOpen ? "true" : "false";
    inputContainer.style.height = this.state.isOpen ? "64px" : "0px";
    inputContainer.style.opacity = this.state.isOpen ? "1" : "0";

    if (this.state.isOpen == false) {
      input.value == "";
    } else {
      input.focus();
    }

    if (hasError) {
      this._clearError();
    }
  };

  _handleSubmit = () => {
    var { input, hasError, handle } = this.state;
    const inputValue = input.value;
    const isValidZipCode = inputValue.match(
      /^\d{5}-\d{4}|\d{5}|[A-Z]\d[A-Z] \d[A-Z]\d$/
    );

    if (isValidZipCode) {
      this._fetchApi(inputValue);

      if (hasError) {
        this._clearError();
      }
    } else {
      this.state.hasError = true;
      input.classList.add("input--error");
      b;
      $(`#ohi-error-${handle}`).html("* Please Enter Valid Zip Code");
    }
  };

  _clearError() {
    var { input, handle } = this.state;
    this.state.hasError = false;
    input.classList.remove("input--error");
    $(`#ohi-error-${handle}`).html("");
  }

  _createMessage(data) {
    const template = data.bestAvailability.template;
    let { city, zip } = data.placeholders;

    this.state.zipCode = zip;

    var ohi_msg = this.state.messages[`${template}`]
      .replace("[zip]", zip)
      .replace("[productname]", this.state.title)
      .replace(/[\])}[{(]/g, "");

    // if the city is undefined remove that area of string and previous comma.
    ohi_msg =
      city == undefined
        ? ohi_msg.replace(", city", "")
        : ohi_msg.replace("city", city);

    this._renderMessage(ohi_msg);
  }

  _displaySpinner(status) {
    this.state.msgContainer.style.opacity = status ? "0" : "1";
    this.state.spinner.style.opacity = status ? "1" : "0";
  }

  _refreshOhiApi() {
    return window.OHIWIDGET.render();
  }

  async _fetchApi(inputValue) {
    const { sku } = this.state;

    this._displaySpinner(true);

    window.OHIWIDGET.setParams({
      zip: inputValue,
      sku: sku,
      productname: this.state.title,
      is_testing: true,
    });
    const result = await this._refreshOhiApi();

    if (window.OHIWIDGET.config == undefined) {
      this._disableControls();
      return;
    }

    this._createMessage(window.OHIWIDGET);
  }

  _getBestAvailability() {
    const order_of_times = ["rush", "same_day", "next_day", "two_day"];
    let best_available = false;
    for (let i = 0; i < order_of_times.length; i++) {
      let type = order_of_times[i];
      if (window.OHIWIDGET.config.availability[`${type}`] == true) {
        best_available = `${type}_availability_message`;
        break;
      }
    }

    return best_available;
  }

  _renderMessage(msg) {
    this._fadeIn();
    setTimeout(() => {
      this.state.toggleBtn.style.opacity = "1";
      this._displaySpinner(false);
      this.state.msgContainer.innerHTML = msg;
    }, 500);
  }

  _buildControls() {
    this.state.toggleBtn.addEventListener("click", this._handleToggle, true);
    this.state.submitBtn.addEventListener("click", this._handleSubmit, true);
    this.state.input.addEventListener("keyup", (event) => {
      if (event.key === "Enter") {
        this._handleSubmit();
      }
    });
  }

  _disableControls() {
    this._renderMessage(this.state.messages.online_only_message);

    this.state.isDisabled = true;
    this.state.inputContainer.style.display = "none";
    this.state.inputContainer.setAttribute("aria-hidden", true);

    this.state.toggleBtn.style.display = "none";
    this.state.inputContainer.setAttribute("aria-hidden", true);

    this._displaySpinner(false);

    this.state.toggleBtn.previousElementSibling.style.maxWidth = "100%";
  }

  _fadeIn() {
    this.state.widget.style.height = "auto";
    this.state.widget.style.opacity = "1";
  }

  _build() {
    var ticks = 0;

    if (this.state.inputContainer == null) {
      return false;
    }

    const refreshInterval = setInterval(() => {
      if (
        window.OHIWIDGET != undefined &&
        window.OHIWIDGET.hasOwnProperty("placeholders")
      ) {
        clearInterval(refreshInterval);

        if (window.OHIWIDGET.config == undefined) {
          this._disableControls();
        } else {
          this._buildControls(this.state.handle);
          this._createMessage(window.OHIWIDGET);
        }
      } else {
        ticks++;
      }

      if (ticks == 8) {
        clearInterval(refreshInterval);
        this._buildControls();
        this._renderMessage(this.state.messages.error_out_message);
        console.error("Ohi API Unresponsive.");
      }
    }, 800);
  }

  _init(data) {
    if (this.state.inputContainer == null) {
      return;
    }
    setTimeout(() => {
      this._displaySpinner(true);
      this._buildControls();

      if (data.config == undefined) {
        this._disableControls();
        return;
      }

      this._createMessage(data);
    }, 500);
  }
}
